(function Module() {
	'use strict';

	mySynch.controller('FertilityCodesLactation2Controller', [
		'$scope',
		'MySynchFactory',
		'FertilityFactory',
		'ViewAuthorizationFactory',
		'mySynchEnumerationService',
		'performanceMetricsService',
		'performanceContextService',
		function FertilityCodesLactation2Controller($s, MSF, fertility, viewAuth,mySynchEnumSvc, perfMetricSvc, perfContextSvc) {
			
			$s.performanceContext = null;

			$s.canUpdate = false;

			// deregistration functions
			var deregOnPermissionChanged = null;
			var deregOnHerdFertilityProgramChanged = null;

			deregOnPermissionChanged = $s.$on('permission:changed', function onPermissionChanged() {
				checkPermissions();
			});

			function checkPermissions() {
				$s.canUpdate = viewAuth.hasPermission(mySynchEnumSvc.getMySynchEnumeration('Permission','LACTATION_2_UPDATE'));
			}

			function doneLoading() {
				$s.loading = false;
				$s.$apply();
			}

			function loadProtocolsOnChange() {
				perfMetricSvc.startTiming('Page:FertilityLactation2OnHerdFertilityProgramChanged:Render');
				perfMetricSvc.startTiming('Page:FertilityLactation2OnHerdFertilityProgramChanged:Build');
				$s.loading = true;
				fertility.resetAll();
				fertility.load.planAndProtocols($s.parityTypeId, $s.performanceContext, () => {
					perfMetricSvc.endTiming("page",'Page:FertilityLactation2OnHerdFertilityProgramChanged:Build', $s.performanceContext);
					doneLoading();
					perfMetricSvc.endTiming("page",'Page:FertilityLactation2OnHerdFertilityProgramChanged:Render', $s.performanceContext);
				});
			}

			$s.loading = true;
			$s.MSF = MSF;
			$s.fertility = fertility;
			$s.parityTypeId = 3; // parity 3 is lactation 2+ and is the parityTypeId for this page

			deregOnHerdFertilityProgramChanged = $s.$on('herdFertilityProgram:changed', loadProtocolsOnChange);

			$s.$on('$destroy', function onDestroy() {
				if (deregOnPermissionChanged) {
					deregOnPermissionChanged();
				}

				if (deregOnHerdFertilityProgramChanged) {
					deregOnHerdFertilityProgramChanged();
				}
				$s.performanceContext = null;
			});

			MSF.ready(function whenMsfReady() {
				$s.performanceContext = perfContextSvc.createPerformanceContext(_.get(MSF.getActiveHerd(),'herdId', null));
				perfMetricSvc.startTiming('Page:FertilityLactation2:Render');
				perfMetricSvc.startTiming('Page:FertilityLactation2:Build');
				checkPermissions();
				fertility.resetAll();
				perfMetricSvc.startTiming('Page:FertilityLactation2HerdFromDb:Request');
				fertility.load.herdFromDb($s.performanceContext, function herdLoaded() {
					perfMetricSvc.endTiming("page",'Page:FertilityLactation2HerdFromDb:Request', $s.performanceContext);
					perfMetricSvc.startTiming('Page:FertilityLactation2PlanAndProtocols:Request');
					fertility.load.planAndProtocols($s.parityTypeId, $s.performanceContext, () => {
						perfMetricSvc.endTiming("page",'Page:FertilityLactation2PlanAndProtocols:Request', $s.performanceContext);
						perfMetricSvc.endTiming("page",'Page:FertilityLactation2:Build', $s.performanceContext);
						doneLoading();
						perfMetricSvc.endTiming("page",'Page:FertilityLactation2:Render', $s.performanceContext);
					});
				});
			});
		}
	]);
})();
